import { render } from "./getBookingList.vue?vue&type=template&id=6f678fac&scoped=true"
import script from "./getBookingList.vue?vue&type=script&lang=js"
export * from "./getBookingList.vue?vue&type=script&lang=js"

import "./getBookingList.vue?vue&type=style&index=0&id=6f678fac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f678fac"

export default script